import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ChevronDownIcon } from 'lucide-react';
const integrations = [{
  name: 'Odoo',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/image.png"
}, {
  name: 'Salesforce',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Salesforce.com_logo.svg/2560px-Salesforce.com_logo.svg.png'
}, {
  name: 'Shopify',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Shopify_logo_2018.svg/2560px-Shopify_logo_2018.svg.png'
}, {
  name: 'Slack',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Slack_icon_2019.svg/2048px-Slack_icon_2019.svg.png'
}, {
  name: 'Xero',
  logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/9/9f/Xero_software_logo.svg/1200px-Xero_software_logo.svg.png'
}, {
  name: 'HubSpot',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/HUBS-3bd277ce.png"
}, {
  name: 'Stripe',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/2560px-Stripe_Logo%2C_revised_2016.svg.png'
}, {
  name: 'WooCommerce',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/WooCommerce-Symbol-1.png"
}, {
  name: 'Microsoft Dynamics',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/icon-dynamics-365.png"
}, {
  name: 'Onshape',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/onshape_download.jpg"
}, {
  name: 'QuickBooks',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/quickbooks.png"
}];
function IsometricGrid() {
  return <div className="relative w-full h-[700px] flex items-center justify-center overflow-hidden perspective-[1000px]" data-id="element-912">
      {/* Central Platform Block */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8
    }} className="relative z-20 flex items-center justify-center" data-id="element-913">

        <img src="https://thruline-public.s3.us-west-1.amazonaws.com/brand/logos/png/logo-dark-trans.png" alt="Thruline" className="h-12 w-auto object-contain" data-id="element-914" />

      </motion.div>

      {/* Grid Lines */}
      <div className="absolute inset-0 pointer-events-none opacity-20" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
      backgroundSize: '40px 40px',
      transform: 'perspective(1000px) rotateX(60deg) rotateZ(45deg) scale(2.5)'
    }} data-id="element-915" />


      {/* Floating Integration Logos */}
      {integrations.map((item, i) => {
      // Calculate positions in a circle/grid around the center
      const angle = i / integrations.length * Math.PI * 2;
      const radius = 300; // Distance from center
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;
      return <motion.div key={item.name} initial={{
        opacity: 0,
        x: 0,
        y: 0
      }} animate={{
        opacity: 1,
        x: x,
        y: y
      }} transition={{
        duration: 0.8,
        delay: i * 0.1
      }} className="absolute w-20 h-20 bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl flex items-center justify-center shadow-lg hover:bg-white/10 transition-colors duration-300" style={{
        left: 'calc(50% - 40px)',
        top: 'calc(50% - 40px)',
        transform: `translateZ(${Math.random() * 50}px)`
      }} data-id="element-916">

            <div className="w-12 h-12 flex items-center justify-center p-2 bg-white rounded-lg" data-id="element-917">
              <img src={item.logo} alt={item.name} className="w-full h-full object-contain" data-id="element-918" />

            </div>

            {/* Connecting line to center (simulated) */}
            <div className="absolute top-1/2 left-1/2 w-[150px] h-[1px] bg-gradient-to-r from-violet-electric/50 to-transparent origin-left -z-10" style={{
          transform: `rotate(${angle + Math.PI}rad)`,
          width: radius
        }} data-id="element-919" />

          </motion.div>;
    })}
    </div>;
}
const faqs = [{
  question: 'What integrations does Thruline support?',
  answer: 'Thruline integrates with major platforms across CRM, accounting, e-commerce, messaging, and more — including QuickBooks, Xero, Salesforce, HubSpot, Shopify, Slack, Stripe, and Microsoft Dynamics. We also support custom integrations via API and webhooks.'
}, {
  question: 'Can you integrate with our proprietary or legacy systems?',
  answer: 'Yes. For systems without standard APIs, we build custom connectors during implementation. File-based integrations, database links, and webhook-driven event processing are all supported. Integration scope is defined during the free discovery phase.'
}, {
  question: 'How long does it take to set up an integration?',
  answer: 'Most pre-built integrations are configured during your implementation project and go live with the rest of your system. Custom integrations are scoped during discovery and included in your fixed-price project — no surprise costs.'
}, {
  question: 'Is data synced in real time?',
  answer: 'Yes. Integrations are bidirectional where needed — data flows in and out of Thruline automatically, eliminating duplicate entry and keeping all systems in sync. You can also configure batch syncs for specific use cases.'
}, {
  question: "What if we need an integration that isn't listed?",
  answer: 'If a system has an API, we can connect to it. During discovery, we assess your integration requirements and include any custom connectors in the project scope. Our team has built integrations with hundreds of systems across manufacturing and operations.'
}];
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="border-b border-white/[0.06] last:border-b-0" data-id="element-920">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between py-6 text-left group" data-id="element-921">

        <span className="text-white font-semibold text-base pr-8 group-hover:text-violet-electric transition-colors" data-id="element-922">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-white/40 flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-923" />

      </button>
      {open && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} className="pb-6" data-id="element-924">

          <p className="text-white/50 text-sm leading-relaxed" data-id="element-925">{answer}</p>
        </motion.div>}
    </div>;
}
export function IntegrationsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-navy text-white font-sans selection:bg-violet-electric/30 pt-32 pb-20" data-id="element-926">
      <div className="max-w-7xl mx-auto px-6" data-id="element-927">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-928">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-violet-electric text-sm font-semibold tracking-widest uppercase mb-6 block" data-id="element-929">

            Connected Ecosystem
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8" data-id="element-930">

            The data foundation that powers unified operations
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl text-white/60 leading-relaxed" data-id="element-931">

            Thruline integrates with all your systems and helps you fully
            customize and control your operations—so your software adapts to
            your strategy, not the other way around.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="mt-10" data-id="element-932">

            <a href="https://calendly.com/alex-thruline/learn-about-thruline" className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/20 hover:bg-white/5 transition-all" data-id="element-933">

              Integrate now
              <ArrowRightIcon className="w-4 h-4" data-id="element-934" />
            </a>
          </motion.div>
        </div>

        {/* Graphic Section */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4,
        duration: 1
      }} className="relative w-full rounded-3xl overflow-hidden bg-gradient-to-b from-navy-light/50 to-navy border border-white/5" data-id="element-935">

          <IsometricGrid data-id="element-936" />

          {/* Categories List */}
          <div className="absolute bottom-8 left-8 text-xs font-medium text-white/60 space-y-1 hidden md:block" data-id="element-937">
            <div data-id="element-938">CRM</div>
            <div data-id="element-939">Databases</div>
            <div data-id="element-940">E-Commerce</div>
            <div data-id="element-941">Email & Messaging</div>
            <div data-id="element-942">Finance & Accounting</div>
            <div data-id="element-943">Marketing & Advertising</div>
            <div data-id="element-944">Procurement</div>
            <div data-id="element-945">Warehousing & Logistics (WMS / TMS)</div>
          </div>
        </motion.div>

        {/* FAQ Section */}
        <motion.section initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="max-w-3xl mx-auto mt-32" data-id="element-946">

          <div className="text-center mb-12" data-id="element-947">
            <span className="text-violet-electric text-xs font-semibold tracking-[0.2em] uppercase block mb-4" data-id="element-948">
              FAQ
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight" data-id="element-949">
              Common questions about integrations
            </h2>
          </div>

          <div className="rounded-2xl border border-white/[0.06] bg-white/[0.02] px-8" data-id="element-950">
            {faqs.map(faq => <FAQItem key={faq.question} question={faq.question} answer={faq.answer} data-id="element-951" />)}
          </div>
        </motion.section>
      </div>
    </div>;
}